import { AssertException } from '../assert.exception';

export class AssertIsNilException extends AssertException {
  constructor(message?: string) {
    super(message);

    Object.setPrototypeOf(this, AssertIsNilException.prototype);
  }
}
